/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { App } from 'store/App/types';
import { IApiList, IPaymentSet, ITipAcceptancePaymentSet, ITipAcceptancePaymentSetPayouts } from '../../../types';
import { Payments } from './types';

const initialState: IApiList<IPaymentSet | ITipAcceptancePaymentSetPayouts> | null = null;

export const paymentsReducer: Reducer<IApiList<IPaymentSet | ITipAcceptancePaymentSetPayouts> | null> = (state = initialState, action) => {
  switch (action.type) {
    case App.SET_CURRENT_EMPLOYEE_SUCCESS:
    case Payments.GET_SITE_PAYMENTS_REQUEST:
    case Payments.GET_SITE_TIP_ACCEPTANCE_PAYMENT_SETS_REQUEST: {
      return initialState;
    }
    case Payments.GET_SITE_PAYMENTS_SUCCESS:
    case Payments.GET_SITE_TIP_ACCEPTANCE_PAYMENT_SETS_SUCCESS: {
      return action.payload;
    }
    case Payments.GET_COMPLETED_PAYMENT_SET_SUCCESS: {
      const paymentSummary = action.payload as IPaymentSet;

      return {
        ...state,
        data: state.data.map((d) => {
          if ((d as ITipAcceptancePaymentSet)?.paymentId !== paymentSummary.id) return d;

          return {
            ...d,
            summary: paymentSummary,
            error: null,
          };
        }),
      };
    }
    case Payments.GET_COMPLETED_PAYMENT_SET_FAIL: {
      const { paymentId, error } = action.payload;

      return {
        ...state,
        data: state.data.map((d) => {
          if ((d as ITipAcceptancePaymentSet)?.paymentId !== paymentId) return d;

          return {
            ...d,
            error,
          };
        }),
      };
    }
    default: {
      return state;
    }
  }
};
